import { render, staticRenderFns } from "./TodayHintsPageCopy.vue?vue&type=template&id=27a47b6c&"
import script from "./TodayHintsPageCopy.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TodayHintsPageCopy.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports